import { forwardRef } from "react";
import { IconPropsType, Ref } from "./IconPropsType";

const AllSports = forwardRef<Ref, IconPropsType>(
  ({ color = "currentColor", size, ...rest }, ref) => {
    return (
      <svg
        width={size ?? 28}
        height={size ?? 28}
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.926"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.668 1.55859C24.8139 1.65319 26.2084 2.7287 26.8515 4.78516C27.5273 8.11727 26.5886 10.8972 24.0351 13.125C22.7498 14.1573 21.2915 14.5401 19.6601 14.2734C18.0853 13.7923 17.0553 12.7623 16.5703 11.1836C15.9137 8.03124 16.7432 5.34243 19.0586 3.11719C20.0898 2.19122 21.2929 1.67169 22.668 1.55859ZM22.1211 2.54297C24.4622 2.52267 25.8385 3.67111 26.25 5.98828C26.4881 8.45551 25.6951 10.5246 23.8711 12.1953C22.7681 13.1546 21.4921 13.5375 20.043 13.3438C18.6557 12.9591 17.7534 12.075 17.3359 10.6914C16.7658 7.93576 17.5222 5.61154 19.6055 3.71875C20.3575 3.133 21.196 2.74107 22.1211 2.54297Z"
          fill={color}
        />
        <path
          opacity="0.882"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.1211 3.03514C22.6467 2.99568 23.1571 3.05948 23.6523 3.22655C23.5192 3.53847 23.3642 3.83925 23.1875 4.12889C22.7002 3.89892 22.2171 3.66194 21.7383 3.41796C21.8065 3.31826 21.843 3.20889 21.8477 3.08983C21.9524 3.10539 22.0435 3.08716 22.1211 3.03514Z"
          fill={color}
        />
        <path
          opacity="0.956"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.82422 3.14454C6.40533 3.1116 6.88838 3.31212 7.27344 3.7461C9.66618 7.2374 12.0724 10.7191 14.4922 14.1914C14.7572 14.6049 14.8392 15.0515 14.7383 15.5313C14.7594 15.9865 14.9052 16.3967 15.1758 16.7617C14.758 16.884 14.3842 17.0845 14.0547 17.3633C13.3829 14.8777 11.8425 13.1824 9.43359 12.2773C7.77973 9.93596 6.16645 7.56618 4.59375 5.16797C4.3928 4.11022 4.80295 3.43575 5.82422 3.14454ZM5.49609 4.45704C5.70763 4.49488 5.83521 4.62248 5.87891 4.83985C5.70024 5.12891 5.5271 5.12891 5.35938 4.83985C5.30012 4.6671 5.34569 4.53949 5.49609 4.45704ZM6.09766 5.38672C6.21682 5.40532 6.31706 5.46001 6.39844 5.55079C7.20213 6.74653 7.99509 7.94965 8.77734 9.16016C8.68011 9.4149 8.52513 9.46958 8.3125 9.32422C7.54223 8.12996 6.75839 6.94504 5.96094 5.76954C5.91511 5.60651 5.96066 5.47893 6.09766 5.38672Z"
          fill={color}
        />
        <path
          opacity="0.878"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.0898 3.41797C24.6403 3.69493 25.0413 4.1142 25.293 4.67578C25.2928 4.9784 25.1652 5.06043 24.9102 4.92188C24.4909 4.72135 24.0716 4.52084 23.6523 4.32031C23.791 4.01559 23.9369 3.71481 24.0898 3.41797Z"
          fill={color}
        />
        <path
          opacity="0.867"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.6992 3.52734C20.8409 3.5617 20.9684 3.62551 21.082 3.71875C20.9076 4.09495 20.7253 4.46865 20.5352 4.83984C20.4276 4.88753 20.3183 4.87841 20.207 4.8125C19.9795 4.70791 19.7608 4.58942 19.5508 4.45703C19.8871 4.08366 20.2699 3.77376 20.6992 3.52734Z"
          fill={color}
        />
        <path
          opacity="0.914"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.5195 3.91016C21.8527 4.03109 22.1809 4.16781 22.5039 4.32031C22.6882 4.39392 22.8523 4.49418 22.9961 4.62109C22.8187 5.03047 22.6273 5.43151 22.4219 5.82422C21.9245 5.59836 21.4414 5.35225 20.9727 5.08594C21.1333 4.68272 21.3156 4.29079 21.5195 3.91016Z"
          fill={color}
        />
        <path
          opacity="0.91"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.4336 4.78516C23.9493 4.99735 24.4597 5.22522 24.9648 5.46875C24.7754 5.89323 24.5658 6.30339 24.3359 6.69922C23.8351 6.48736 23.3519 6.2504 22.8867 5.98828C23.0799 5.59048 23.2622 5.18947 23.4336 4.78516Z"
          fill={color}
        />
        <path
          opacity="0.905"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.168 4.83984C19.5487 5.00584 19.9133 5.19724 20.2617 5.41406C20.1086 5.83882 19.9081 6.23077 19.6602 6.58984C19.2328 6.40352 18.8135 6.20298 18.4023 5.98828C18.6161 5.57473 18.8713 5.19193 19.168 4.83984Z"
          fill={color}
        />
        <path
          opacity="0.911"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.6992 5.60547C21.2393 5.78446 21.7498 6.02142 22.2305 6.31641C22.0296 6.7194 21.8291 7.12042 21.6289 7.51953C21.139 7.2864 20.6468 7.05852 20.1523 6.83594C20.3574 6.43508 20.5396 6.02492 20.6992 5.60547Z"
          fill={color}
        />
        <path
          opacity="0.863"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.4023 5.66016C25.5875 5.70177 25.706 5.81115 25.7578 5.98828C25.8226 6.44175 25.8499 6.89746 25.8398 7.35547C25.4775 7.24724 25.1494 7.08318 24.8555 6.86328C25.0384 6.46111 25.2207 6.06003 25.4023 5.66016Z"
          fill={color}
        />
        <path
          opacity="0.907"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.1289 6.48047C18.2418 6.4907 18.3512 6.51804 18.457 6.5625C18.8153 6.73241 19.1616 6.91469 19.4961 7.10938C19.3242 7.49782 19.1419 7.88063 18.9492 8.25781C18.5601 8.13679 18.1772 7.9818 17.8008 7.79297C17.7826 7.75649 17.7643 7.72007 17.7461 7.68359C17.8522 7.27426 17.9798 6.87323 18.1289 6.48047Z"
          fill={color}
        />
        <path
          opacity="0.912"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.668 6.48047C23.1604 6.67652 23.6435 6.89527 24.1172 7.13672C24.0161 7.59407 23.8247 8.0133 23.543 8.39453C23.0502 8.18459 22.5762 7.94763 22.1211 7.68359C22.3042 7.28115 22.4865 6.88007 22.668 6.48047Z"
          fill={color}
        />
        <path
          opacity="0.912"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.9336 7.30078C20.4633 7.48355 20.9737 7.71143 21.4648 7.98438C21.272 8.39754 21.0714 8.8077 20.8633 9.21484C20.3627 8.99188 19.8705 8.75492 19.3867 8.50391C19.5698 8.10146 19.7521 7.70038 19.9336 7.30078Z"
          fill={color}
        />
        <path
          opacity="0.907"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.582 7.35547C24.9454 7.51888 25.31 7.68294 25.6758 7.84766C25.6964 8.33049 25.587 8.7862 25.3477 9.21484C24.9018 9.01923 24.4643 8.80961 24.0352 8.58594C24.2402 8.18508 24.4225 7.77492 24.582 7.35547Z"
          fill={color}
        />
        <path
          opacity="0.912"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.8477 8.17578C22.3638 8.35707 22.8651 8.57582 23.3516 8.83203C23.2192 9.25269 23.046 9.66284 22.832 10.0625C22.3383 9.89352 21.8552 9.68384 21.3828 9.43359C21.3463 9.37891 21.3463 9.32422 21.3828 9.26953C21.5539 8.90952 21.7088 8.54492 21.8477 8.17578Z"
          fill={color}
        />
        <path
          opacity="0.885"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.6367 8.28516C18.0148 8.41947 18.3793 8.58353 18.7305 8.77734C18.5604 9.20888 18.3508 9.60996 18.1015 9.98047C17.9481 9.92195 17.8022 9.84905 17.664 9.76172C17.5639 9.27128 17.5548 8.77909 17.6367 8.28516Z"
          fill={color}
        />
        <path
          opacity="0.912"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.168 8.99609C19.6645 9.18591 20.1567 9.38645 20.6445 9.59766C20.4983 10.0542 20.3069 10.4917 20.0703 10.9102C19.5729 10.6843 19.0899 10.4382 18.6211 10.1719C18.7817 9.76866 18.964 9.37672 19.168 8.99609Z"
          fill={color}
        />
        <path
          opacity="0.903"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.8164 9.05078C24.2819 9.24853 24.7376 9.46728 25.1836 9.70703C24.9955 10.1389 24.7403 10.5217 24.418 10.8555C24.0145 10.6852 23.6317 10.4847 23.2695 10.2539C23.4627 9.85611 23.645 9.45509 23.8164 9.05078Z"
          fill={color}
        />
        <path
          opacity="0.911"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.082 9.87109C21.6116 10.0659 22.122 10.3029 22.6133 10.582C22.4119 10.9848 22.2114 11.3858 22.0117 11.7852C21.5112 11.5622 21.019 11.3252 20.5352 11.0742C20.7481 10.685 20.9304 10.284 21.082 9.87109Z"
          fill={color}
        />
        <path
          opacity="0.359"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.8008 10.418C17.8601 10.4245 17.8966 10.461 17.9101 10.5273C17.8919 10.5638 17.8737 10.6002 17.8554 10.6367C17.8046 10.5717 17.7864 10.4988 17.8008 10.418Z"
          fill={color}
        />
        <path
          opacity="0.901"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.3477 10.6914C18.864 10.872 19.3653 11.0908 19.8516 11.3477C19.7128 11.762 19.5305 12.1631 19.3047 12.5508C18.7972 12.2257 18.4053 11.7974 18.1289 11.2656C18.195 11.0701 18.2679 10.8787 18.3477 10.6914Z"
          fill={color}
        />
        <path
          opacity="0.88"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.0508 10.7461C23.4222 10.9045 23.7868 11.0777 24.1445 11.2656C23.8154 11.6682 23.4235 11.9872 22.9688 12.2227C22.7902 12.1655 22.6353 12.0744 22.5039 11.9492C22.687 11.5468 22.8693 11.1457 23.0508 10.7461Z"
          fill={color}
        />
        <path
          opacity="0.906"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.3164 11.5664C20.8089 11.7625 21.292 11.9812 21.7656 12.2227C21.7202 12.4426 21.6565 12.6614 21.5742 12.8789C20.96 12.982 20.3584 12.9364 19.7695 12.7422C19.9596 12.353 20.1419 11.961 20.3164 11.5664Z"
          fill={color}
        />
        <path
          opacity="0.964"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.64453 12.4414C7.00913 12.4414 7.37368 12.4414 7.73828 12.4414C7.48863 14.0777 7.88971 15.5269 8.94141 16.7891C8.4052 17.3891 7.84005 17.9633 7.24609 18.5117C5.77938 17.0723 4.32106 15.6231 2.87109 14.1641C3.9405 13.1736 5.19831 12.5993 6.64453 12.4414Z"
          fill={color}
        />
        <path
          opacity="0.338"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.2305 12.6055C22.234 12.4142 22.307 12.3868 22.4492 12.5234C22.3911 12.5884 22.3181 12.6158 22.2305 12.6055Z"
          fill={color}
        />
        <path
          opacity="0.957"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.23047 12.4961C9.5357 12.6993 10.6659 13.2461 11.6211 14.1367C10.8737 14.9206 10.1081 15.6862 9.32422 16.4336C8.33088 15.3048 7.96628 13.9923 8.23047 12.4961Z"
          fill={color}
        />
        <path
          opacity="0.919"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.2383 14.1914C18.5252 14.3804 18.8351 14.5262 19.168 14.6289C19.2272 14.6762 19.2363 14.7309 19.1953 14.793C18.8431 15.5156 18.5059 16.2448 18.1836 16.9805C18.0406 17.0608 17.8857 17.0973 17.7187 17.0898C17.4702 17.0664 17.2241 17.0299 16.9805 16.9805C17.3846 16.0447 17.8038 15.115 18.2383 14.1914Z"
          fill={color}
        />
        <path
          opacity="0.97"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.48827 14.5195C3.98757 15.9367 5.46413 17.3859 6.91796 18.8672C6.35971 19.4438 5.78549 19.9997 5.1953 20.5352C3.92641 19.5 2.47719 19.099 0.847645 19.332C0.729777 17.4981 1.27665 15.8939 2.48827 14.5195Z"
          fill={color}
        />
        <path
          opacity="0.952"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.9492 14.5195C12.5894 15.1227 13.0542 15.8519 13.3438 16.707C13.4683 17.084 13.5686 17.4668 13.6445 17.8555C12.182 18.1484 10.8786 17.8203 9.73439 16.8711C9.69791 16.8164 9.69791 16.7617 9.73439 16.707C10.5003 16.0049 11.2386 15.2757 11.9492 14.5195Z"
          fill={color}
        />
        <path
          opacity="0.966"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.26954 17.1445C10.5508 18.2171 12.0274 18.6364 13.6992 18.4023C13.8053 20.2541 13.2401 21.8583 12.0039 23.2148C10.563 21.7831 9.11379 20.3612 7.65626 18.9492C7.61979 18.8945 7.61979 18.8398 7.65626 18.7852C8.20511 18.2455 8.74285 17.6986 9.26954 17.1445Z"
          fill={color}
        />
        <path
          opacity="0.962"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.9805 17.1445C24.2483 17.1568 24.5035 17.2206 24.7461 17.3359C25.1191 17.6409 25.5019 17.9325 25.8945 18.2109C25.3208 18.6347 24.7192 19.0175 24.0898 19.3594C23.7799 19.3959 23.4701 19.3959 23.1602 19.3594C21.2646 19.2149 19.3688 19.0782 17.4727 18.9492C17.5708 18.4949 17.662 18.0392 17.7461 17.582C19.8332 17.4494 21.9114 17.3035 23.9805 17.1445Z"
          fill={color}
        />
        <path
          opacity="0.941"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.2305 17.2539C15.4702 17.2361 15.7072 17.2544 15.9414 17.3086C15.6372 18.6927 15.3365 20.0781 15.0391 21.4649C15.0022 21.5238 14.9475 21.5603 14.875 21.5742C14.5284 21.5317 14.2185 21.4041 13.9453 21.1914C13.9026 21.1242 13.8753 21.0513 13.8633 20.9727C14.1595 20.0527 14.2506 19.1139 14.1367 18.1563C14.208 17.8677 14.3721 17.6489 14.6289 17.5C14.8289 17.4004 15.0294 17.3183 15.2305 17.2539Z"
          fill={color}
        />
        <path
          opacity="0.918"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.4336 17.3633C16.6733 17.3912 16.9104 17.4367 17.1445 17.5C17.2001 17.5284 17.2365 17.574 17.2539 17.6367C16.9481 19.0382 16.6564 20.4419 16.3789 21.8477C16.09 21.779 15.7984 21.7243 15.5039 21.6836C15.7931 20.2375 16.103 18.7975 16.4336 17.3633Z"
          fill={color}
        />
        <path
          opacity="0.97"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.19141 19.2227C8.70056 20.6406 10.1771 22.0989 11.6211 23.5977C10.2555 24.8125 8.65134 25.3777 6.80859 25.293C7.05135 23.6382 6.63206 22.1798 5.55078 20.918C6.0988 20.3517 6.64568 19.7866 7.19141 19.2227Z"
          fill={color}
        />
        <path
          opacity="0.957"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.3633 19.4414C19.6053 19.5949 21.8475 19.7499 24.0898 19.9062C24.6185 20.4349 25.1471 20.9635 25.6758 21.4922C24.9295 21.8562 24.1639 22.1752 23.3789 22.4492C21.3242 21.7044 19.2643 20.9752 17.1992 20.2617C17.247 19.9866 17.3016 19.7131 17.3633 19.4414Z"
          fill={color}
        />
        <path
          opacity="0.954"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.12109 19.7695C2.53961 19.6045 3.7792 19.9874 4.83984 20.918C4.09245 21.7018 3.32682 22.4674 2.54297 23.2149C1.61756 22.2753 1.07069 21.1451 0.902344 19.8242C0.989789 19.8389 1.06271 19.8206 1.12109 19.7695Z"
          fill={color}
        />
        <path
          opacity="0.955"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.0898 20.6992C19.1503 21.4499 21.2102 22.2064 23.2695 22.9688C23.7291 23.5273 24.1301 24.1198 24.4727 24.7461C23.9304 24.8907 23.3836 25.0183 22.832 25.1289C22.643 25.1115 22.4608 25.0659 22.2852 24.9922C20.5352 24.0443 18.7852 23.0963 17.0352 22.1484C16.9352 22.0993 16.8623 22.0263 16.8164 21.9297C16.9181 21.5212 17.0093 21.1111 17.0898 20.6992Z"
          fill={color}
        />
        <path
          opacity="0.948"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.11328 21.3008C5.32367 21.4105 5.49686 21.5745 5.63281 21.793C6.30241 22.8574 6.51202 24.0058 6.26172 25.2383C5.2946 25.0645 4.40137 24.709 3.58203 24.1719C3.33698 23.9956 3.11823 23.7951 2.92578 23.5703C3.64548 22.805 4.37465 22.0485 5.11328 21.3008Z"
          fill={color}
        />
        <path
          opacity="0.968"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.3008 22.6133C15.6521 22.5338 16.4177 23.1627 16.5977 24.5C16.4794 25.6391 15.8505 26.268 14.7109 26.3867C13.337 26.1978 12.7172 25.414 12.8516 24.0352C13.077 23.2902 13.56 22.8162 14.3008 22.6133Z"
          fill={color}
        />
        <path
          opacity="0.81"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.0742 23.3242C18.0775 23.2945 18.0957 23.2763 18.1289 23.2695C18.6663 23.5473 19.195 23.839 19.7148 24.1445C19.4929 24.3299 19.256 24.494 19.0039 24.6367C18.6909 24.197 18.381 23.7595 18.0742 23.3242Z"
          fill={color}
        />
        <path
          opacity="0.908"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.1524 24.418C20.4472 24.5379 20.7388 24.6746 21.0274 24.8281C21.1429 24.8777 21.1884 24.9597 21.1641 25.0742C20.7847 25.4173 20.3745 25.7181 19.9336 25.9766C19.4318 26.1555 19.0217 26.037 18.7031 25.6211C18.6667 25.5664 18.6667 25.5117 18.7031 25.457C19.1947 25.1162 19.6778 24.7698 20.1524 24.418Z"
          fill={color}
        />
      </svg>
    );
  },
);

export default AllSports;
